import React from 'react';
import { Badge } from '../ui/badge';
import { FeatherClock, FeatherCheckCircle } from '../ui/icons';
import './TaskHistoryTimeline.css';

const TaskHistoryTimeline = ({ history }) => {
    if (!history || history.length === 0) {
        return null;
    }

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            month: 'short', 
            day: 'numeric',
            year: 'numeric'
        });
    };

    const getStatusVariant = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
                return 'success';
            case 'in-progress':
                return 'warning';
            default:
                return 'neutral';
        }
    };

    return (
        <div className="task-history-timeline">
            <div className="task-history-timeline-title">Task History</div>
            <div className="task-history-timeline-list">
                {history.map((entry, index) => (
                    <div key={entry.work_plan_id || index} className="task-history-timeline-item">
                        <div className="task-history-timeline-dot">
                            {entry.status === 'completed' ? (
                                <FeatherCheckCircle size={16} />
                            ) : (
                                <FeatherClock size={16} />
                            )}
                        </div>
                        <div className="task-history-timeline-content">
                            <div className="task-history-timeline-header">
                                <span className="task-history-timeline-date">
                                    {formatDate(entry.work_plan_date)}
                                </span>
                                <Badge variant={getStatusVariant(entry.status)}>
                                    {entry.status}
                                </Badge>
                            </div>
                            <div className="task-history-timeline-details">
                                {entry.hours > 0 && (
                                    <span className="task-history-timeline-hours">
                                        {entry.hours}h
                                    </span>
                                )}
                                {entry.notes && (
                                    <span className="task-history-timeline-notes">
                                        {entry.notes}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TaskHistoryTimeline;

